import React from "react";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import DpaLinkItem from "../cards/DpaLinkItem";

export default class DpaHeadlinesSectionBuilder {
    static build(pos, title, dpaData) {
        let titleGrids;
        let grids = [];
        let cardno = 0;
        let style = {};


        let singleTitle =
            <Grid
                item xs={12}
                key={'gridpos' + pos + 'gridTitleSingle_DPA'}
                style={style}
            >
                {title}
            </Grid>;
        let doubleTitle =
            <Grid
                item xs={12}
                key={'gridpos' + pos + 'gridTitleDouble_DPA'}
                style={style}
            >
                {title}
            </Grid>;
        if (title == null) {
            singleTitle = null;
            doubleTitle = null;
        }
        titleGrids = [singleTitle, doubleTitle];

        let styleParent = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: "100%",
            alignItems: "center"
        }
        let stylePadding = {
            paddingTop: 0,
            paddingBottom: 0,
            marginTop:-16,
            width:"100%"
        }

        for (let dpaEntry of dpaData) {
            if (cardno > 5) break;
            //onTap("/entry/${article.news.id!}", article.news);
            let card = <DpaLinkItem title={dpaEntry.title} url={"/entry/" + dpaEntry.id} smallPadding={true}/>;
            let doubleDiv = null;
            let doubleDiv2 = null;
            let singleDiv = null;
            let singleDiv2 = null;
            if (cardno === 0 || cardno === 1) {
                doubleDiv = <Divider style={{height: 2, width: "100%", backgroundColor:'#D9D9D9'}}/>
                doubleDiv2 = <div style={{paddingBottom:16}}></div>
            }
            if (cardno === 0) {
                singleDiv = <Divider style={{height: 2, width: "100%", backgroundColor:'#D9D9D9'}}/>
                singleDiv2 = <div style={{paddingBottom:16}}></div>
            }

            const single = cardno > 2 ? null :
                <Grid
                    item xs={12}
                    key={'gridpos' + pos + 'grid_single' + cardno}
                >
                    <div style={styleParent}>
                        {singleDiv}

                        <div style={stylePadding}>
                            {singleDiv2}
                            {card}
                        </div>
                        <Divider style={{height: 2,
                            width: "100%", backgroundColor:'#D9D9D9'}}/>
                    </div>
                </Grid>;


            const double = <Grid
                item xs={6}
                key={'gridpos' + pos + 'grid_double' + cardno}>
                <div style={{display: "flex",flexDirection: "column", justifyContent: "space-between", height: "100%", alignItems: "center"}}>
                    {doubleDiv}
                    <div style={stylePadding}>
                        {doubleDiv2}
                        {card}
                    </div>
                    <Divider style={{height: 2,
                        width: "100%", backgroundColor:'#D9D9D9'}}/>

                </div>
            </Grid>
            grids.push([single, double]);


            cardno++;
        }

        let singleFooter =
            <Grid
                item xs={12}
                key={'gridpos' + pos + 'gridTitleSingle'}
                style={style}
            >
                <DpaLinkItem title={"weitere Nachrichten" } footer={true} url={"/dpa-news"}/>
            </Grid>;
        let doubleFooter =
            <Grid
                item xs={12}
                key={'gridpos' + pos + 'gridTitleDouble'}
                style={style}
            >
                <DpaLinkItem title={"weitere Nachrichten"} footer={true} url={"/dpa-news"}/>
            </Grid>;

        grids.push([singleFooter, doubleFooter]);

        return [titleGrids, grids];
    }
}
